import { useTranslation } from 'react-i18next';
import { useGetAuthApi } from '@/hooks/UseApiCalls';
import { FeatureFlagDetailDtoIn } from '@/models/in/FeatureFlagDtoIn';
import useNameMaps from './useNameMaps';
import { targetingLines } from './targetingNames';

/**
 * The names behind «4 פרויקטים · 2 תפקידים» in the flags list. Mounted only while the hover shows,
 * so the flag's detail is fetched for the row pointed at, not for every row.
 */
const TargetingNamesHint = ({ featureKey }: { featureKey: string }) => {
  const { t } = useTranslation();
  const { data: detail, isLoading } = useGetAuthApi<FeatureFlagDetailDtoIn>(`management/feature-flags/${featureKey}`);
  const { maps, isLoading: namesLoading } = useNameMaps();

  if (isLoading || namesLoading || !detail) return <span className="muted">{t('loading')}</span>;
  const lines = targetingLines(
    { fundIds: detail.fundIds ?? [], groupIds: detail.groupIds ?? [], userEmails: detail.userEmails ?? [], classifications: detail.classifications ?? [], roles: detail.roles ?? [] },
    maps,
    t,
  );
  if (lines.length === 0) return <span>{t('featureFlags.summary.none')}</span>;
  return (
    <>
      {lines.map((line) => (
        <div key={line}>{line}</div>
      ))}
    </>
  );
};

export default TargetingNamesHint;
